import React, { createContext, useState, useContext, useEffect } from 'react'

const AuthContext = createContext(undefined)

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('authToken')
  )
  const [token, setToken] = useState(localStorage.getItem('authToken'))
  const [address, setAddress] = useState(localStorage.getItem('userAddress'))
  const [profile, setProfile] = useState(null)

  const handleSetAuth = (newToken, newAddress) => {
    localStorage.setItem('authToken', newToken)
    localStorage.setItem('userAddress', newAddress)
    setToken(newToken)
    setAddress(newAddress)
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('userAddress')
    setToken(null)
    setAddress(null)
    setIsAuthenticated(false)
    setProfile(null)
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        token,
        address,
        profile,
        setProfile,
        setAuth: handleSetAuth,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}